import { Defaults } from 'es-decorators'
import Backbone from 'init/backbone'
import $ from 'init/jquery'
import { View } from 'es6/components/view'
import { getTemplate } from 'helpers/template-helper'
import { Counterparties } from 'es6/collections/counterparties'
import { MobilePopupFillView } from 'mobile/es6/common/views/mobile-popup-fill-view'
import { Popup } from 'es6/libs/popup'
import { positionCenterOfWindow } from 'helpers/popup-positioning-helper'
import { UploadFilesFormView } from '../upload-files-form-view'

/**
 * Представление упрощённой формы запроса на возврат денежных средств.
 */
@Defaults({
  events: {
    'change .js-select-counterparty': 'renderForm',
    'click .btn-act-of-reconciliation': 'openActOfReconciliationPopup',
    'click .js-back': 'triggerStepBackEvent',
    'click .js-popup-close': 'closePopup',
  },
  refundRequestForm: '#refund-request-form',
  physicalFormFields: {
    refund_application_file: 'Заявление на возврат средств',
  },
  juridicalFormFields: {
    refund_application_file: 'Заявление на возврат средств',
    act_of_reconciliation_file: 'Подписанный акт сверки',
  },
  additionalOptions: [
    'opener',
    'fader',
    'counterparties',
    'preSelect',
    'isMobile',
    'bodyView',
  ],
})
export class SimpleRefundPopupFormView extends View {
  /**
   * @inheritDoc
   */
  run () {
    this.counterpartiesListTemplate = getTemplate('#counterparties-list')
    this.formTemplate = getTemplate(this.refundRequestForm)
    if (!this.counterparties) {
      this.counterparties = new Counterparties()
      this.listenToOnce(this, 'prepare-popup', this.fetchData)
    } else {
      this.initPopup(false)
    }
  }

  /**
   * Запрос контрагентов
   */
  fetchData () {
    this.listenToOnce(this.counterparties, 'sync', this.initPopup)
    this.counterparties.fetch()
  }

  /**
   * Выбирает нужную опцию соответствующую контрагенту, если на странице есть список контрагентов.
   * @param {number} counterPartyId - идентификатор контрагента.
   */
  selectCounterpartyOption (counterPartyId) {
    let option = this.$('option[data-counterparty-id="' + counterPartyId + '"]')
    if (!option.attr('selected')) {
      this.$('select option').removeAttr('selected')
      option.attr('selected', 'selected')
      option.trigger('change')
    }
  }

  /**
   * Инициализация попапа.
   * @param {boolean} initOpened - инициализировать попап открытым.
   */
  initPopup (initOpened) {
    if (this.isMobile) {
      this.childViews.mobilePopupView = new MobilePopupFillView({
        el: this.el,
        $opener: this.opener,
        bodyView: this.bodyView,
      })
      this.popup = this.childViews.mobilePopupView.popup
    } else {
      this.popup = new Popup(this.$el, this.opener)
      this.popup.addEventListener(
        Popup.EventType.BEFORE_CLOSE,
        this.handlePopupClose.bind(this)
      )
    }

    this.popup.addEventListener(
      Popup.EventType.BEFORE_OPEN,
      this.handlePopupOpen.bind(this)
    )

    if (initOpened) {
      this.renderCounterpartySelect()
      this.popup.open()
    }
  }

  /**
   * Рендер поля выбора контрагента.
   */
  renderCounterpartySelect () {
    this.$el.html(this.counterpartiesListTemplate({
      counterparties: this.counterparties,
    }))
  }

  /**
   * Выполняется перед открытием попапа
   * @param {Event} event - событие открытия попапа.
   * @param {Object} opener - инициатор открытия.
   */
  handlePopupOpen (event, opener) {
    if (this.preSelect) {
      this.renderCounterpartySelect()
      let $opener = $(opener.target.currentTarget)
      let counterPartyId = $opener.parent().attr('data-counterparty-id')
      this.selectCounterpartyOption(counterPartyId)
    }
    if (!this.isMobile) {
      this.fader.show()
      positionCenterOfWindow(this.$el)
    }
  }

  /**
   * Выполняется перед закрытием попапа
   */
  handlePopupClose () {
    this.fader.hide()
  }

  /**
   * Отрисовка формы
   * @param {Event} e Событие клика по кнопке открытия.
   * @param {number} counterpartyId Идентификатор контрагента.
   * @param {boolean} withBackBtn Показывать кнопку "назад" в хедере.
   */
  renderForm (e, counterpartyId, withBackBtn) {
    this.counterpartyId = counterpartyId
    let isPhysicalCounterparty = false
    counterpartyId = counterpartyId || 0
    if (e) {
      let el = $(e.currentTarget).find('.counterparty-item:selected')
      isPhysicalCounterparty = el.data('person')
      counterpartyId = el.data('counterparty-id')
    }
    this.formFields = isPhysicalCounterparty
      ? this.physicalFormFields
      : this.juridicalFormFields

    if (withBackBtn) {
      this.$('.js-popup-close').addClass('not_display')
      this.$('.js-back').removeClass('not_display')
    }

    this.$('.refund-request-form').html(this.formTemplate({
      formFields: this.formFields,
      isPhysicalCounterparty: isPhysicalCounterparty,
      counterpartyId: counterpartyId,
    }))

    if (!this.childViews.uploadFilesFormView) {
      this.childViews.uploadFilesFormView = new UploadFilesFormView({
        additionalData: {
          user_id: this.user.get('id'),
          counterparty_id: counterpartyId,
        },
      })
      this.listenTo(this.childViews.uploadFilesFormView, 'upload-success', this.uploadSuccess)
    }
    this.childViews.uploadFilesFormView.clearData()
    this.childViews.uploadFilesFormView.setElement(this.$('#simple-refund-request-form'))
  }

  /**
   * Открытие попапа запроса акта сверки.
   * @param {Event} e Событие клике по кнопке запроса акта сверки.
   */
  openActOfReconciliationPopup (e) {
    this.closePopup()
    Backbone.trigger('open-act-of-reconciliation-popup', e)
  }

  /**
   * Закрытие попапа при успешной отправке формы.
   */
  uploadSuccess () {
    this.closePopup()
    this.showSuccessPopup()
  }

  /**
   * Показывает попап успешной отправки.
   */
  showSuccessPopup () {
    if (!this.successPopup) {
      this.successPopup = new Popup($('.js-success-refund-request'))
    }
    this.successPopup.open()
  }

  /**
   * Закрывает попап
   */
  closePopup () {
    this.popup.close()
  }

  /**
   * Триггерит событие step-back.
   * @param {Event} e Событие клике по кнопке "назад"
   */
  triggerStepBackEvent (e) {
    e.preventDefault()
    e.stopPropagation()
    this.popup.close()
    this.trigger('step-back', e, this.counterpartyId)
  }
}
